// hues with same hue and lightness
import { FIRST_HUE } from '@/color/constants/firstHue';
import { rotateArrayToFirst } from '@/color/helpers/rotateArrayToStart';
export const hues = [
    { hue: '2.5R', color: '#fc0053' },
    { hue: '5R', color: '#fa0037' },
    { hue: '7.5R', color: '#f5000f' },
    { hue: '10R', color: '#ff5800' },
    { hue: '2.5YR', color: '#ff7e00' },
    { hue: '5YR', color: '#ff8c00' },
    { hue: '7.5YR', color: '#ffaf00' },
    { hue: '10YR', color: '#ffb700' },
    { hue: '2.5Y', color: '#ffbe00' },
    { hue: '5Y', color: '#efc600' },
    { hue: '7.5Y', color: '#e2ca00' },
    { hue: '10Y', color: '#d5cf00' },
    { hue: '2.5GY', color: '#c3d400' },
    { hue: '5GY', color: '#a9da00' },
    { hue: '7.5GY', color: '#6be400' },
    { hue: '10GY', color: '#00f000' },
    { hue: '2.5G', color: '#00f548' },
    { hue: '5G', color: '#00f58b' },
    { hue: '7.5G', color: '#00f2a0' },
    { hue: '10G', color: '#00f2b2' },
    { hue: '2.5BG', color: '#00f0c5' },
    { hue: '5BG', color: '#00ecd5' },
    { hue: '7.5BG', color: '#00ebe8' },
    { hue: '10BG', color: '#00e7f5' },
    { hue: '2.5B', color: '#00cdf8' },
    { hue: '5B', color: '#00c5ff' },
    { hue: '7.5B', color: '#00a8fc' },
    { hue: '10B', color: '#008bf1' },
    { hue: '2.5PB', color: '#0083f7' },
    { hue: '5PB', color: '#007cfa' },
    { hue: '7.5PB', color: '#4768ff' },
    { hue: '10PB', color: '#8555ff' },
    { hue: '2.5P', color: '#b12bff' },
    { hue: '5P', color: '#cd00ff' },
    { hue: '7.5P', color: '#eb00f6' },
    { hue: '10P', color: '#fd00df' },
    { hue: '2.5RP', color: '#fb00b8' },
    { hue: '5RP', color: '#ff0096' },
    { hue: '7.5RP', color: '#fd007f' },
    { hue: '10RP', color: '#f90067' },
];
export const MUNSELL_HUES = rotateArrayToFirst(hues, (h) => h.hue === FIRST_HUE);
export const PRINCIPAL_HUES = ['5R', '5Y', '5G', '5B', '5P'];
